module.exports = __webpack_public_path__ + "static/media/date-cross.svg";